// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"JournalImg_imageContainer__DjuLO","image":"JournalImg_image__yeaes"};